import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              About <span className="purple">Me</span>
            </h1>
            <p className="home-about-body">
              I’m a backend-focused full stack developer with 9+ years of
              experience designing and delivering scalable web applications.
              <br />
              <br />
              My strongest value is on the backend:
              <i>
                <b className="purple">
                  {" "}
                  API architecture, data modeling, performance optimization, and
                  cloud delivery{" "}
                </b>
              </i>
              — building platforms that stay stable as teams, traffic, and
              complexity grow.
              <br />
              <br />
              Core stack:{" "}
              <span className="purple">
                Node.js, Laravel, TypeScript, React/Next.js, MySQL/PostgreSQL,
                AWS
              </span>
              <br />
              <br />
              I care about clean boundaries, predictable APIs, and performance
              under real production load.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
